import { render, staticRenderFns } from "./recoverPassword3.vue?vue&type=template&id=6c5b66e2&scoped=true"
import script from "./recoverPassword3.vue?vue&type=script&lang=js"
export * from "./recoverPassword3.vue?vue&type=script&lang=js"
import style0 from "./recoverPassword3.vue?vue&type=style&index=0&id=6c5b66e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5b66e2",
  null
  
)

export default component.exports